import { PermissionMapping } from '@@/lib/permissions';

//i.e reader/writer/business-user = token passed to page component to handle page permissions
//i.e Array of permissions = a permission the user might have which would grant the key's level of access

export type CampaignsPermission = 'reader' | 'writer' | 'admin';

export const campaignsPermissionMapping: PermissionMapping<CampaignsPermission>[] = [
  {
    permissionSetMapping: {
      reader: ['campaigns-admin'],
      writer: ['campaigns-admin'],
      admin: ['campaigns-admin']
    },
    urlSignature: '/',
    showInNavbar: true,
    label: 'Dashboard'
  },
  {
    permissionSetMapping: {
      reader: ['campaigns-admin'],
      writer: ['campaigns-admin'],
      admin: ['campaigns-admin']
    },
    urlSignature: '/create',
    showInNavbar: true,
    label: 'Create Campaign'
  }
];
